import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Input, } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import Modal from 'react-responsive-modal'
import CustomSelect from '../../../components/CustomSelect'
import { createDocumentJournal, updateDocumentJournal } from '../../../actions/documents_journal'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import { getteachers } from '../../../actions/personnel/personnel'
import { getStudents } from '../../../actions/students/list'
import { getTeachersList } from '../../../actions/common'


const validationSchema = Yup.object({
  owner: Yup.string().required('обязательное поле'),
  mid: Yup.number().nullable().required('обязательное поле'),
  dtype: Yup.number().nullable().required('обязательное поле'),
  ddate: Yup.string().required('обязательное поле'),
  dseries: Yup.string().max(30, 'не более 30 символов'),
  dnum: Yup.string().max(30, 'не более 30 символов'),
  dtext: Yup.string().max(200, 'не более 200 символов'),
})

const arrHow = [{ name: 'Преподаватель', value: 'Преподаватель' }, { name: 'Учащийся', value: 'Учащийся' }]

export default function ModalComponent({ data, closeModal, params, typeOfDocumentslist }) {

  const dispatch = useDispatch()

  const { teachers } = useSelector((state) => state.common)
  const { studentList } = useSelector(state => state.students.list) || {}

  const [image, setImage] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true)

  const addMode = !data.xp_key

  const handleCreate = async (values) => {
    const success = await dispatch(createDocumentJournal(values, params))
    if (success) closeModal()
  }

  const handleUpdate = async (values) => {
    const success = await dispatch(updateDocumentJournal(values, params, image))
    if (success) closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? { dseries: '', dnum: '', dtext: '' } : data,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  // 19.03.2026 - Преобразование "Учителя" в "Преподаватель", "Учащиеся" в "Учащийся" для дропдауна
  useEffect(() => {
    if (data.owner === 'Учителя') {
      setFieldValue('owner', 'Преподаватель')
    } else if (data.owner === 'Учащиеся') {
      setFieldValue('owner', 'Учащийся')
    }
  }, [])

  // 19.03.2026 - При изменении владельца отправляем запрос на получение списка
  useEffect(() => {
    if (values.owner === 'Преподаватель' || values.owner === 'Учителя') {
      dispatch(getTeachersList())
    } else if (values.owner === 'Учащийся' || values.owner === 'Учащиеся') {
      dispatch(getStudents({ status: 'all' }))
    }
    if (!initialLoad) {
      setFieldValue('mid', null)
    } else {
      setInitialLoad(false)
    }
  }, [values.owner])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]


  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} style={{ display: "flex", justifyContent: 'space-evenly', flexDirection: 'column' }}>

            <div className={styles.inputsRow}>
              <CustomSelect
                title='Владелец'
                valuesName="owner"
                className={styles.selectModal}
                options={arrHow}
                width='120px'
                value={values.owner}
                setFieldValue={setFieldValue}
                withoutAll
                required
                error={error('owner')}
              />
            </div>
            <div className={styles.inputsRow}>
              <CustomSelect
                key={`fio-${values.owner}-${teachers?.length || 0}-${studentList?.length || 0}`}
                title='ФИО'
                valuesName="mid"
                className={styles.selectModal}
                options={
                  (values.owner === 'Преподаватель' || values.owner === 'Учителя')
                    ? teachers && arrayForSelect(teachers, 'calc_fio', 'mid')
                    : (values.owner === 'Учащийся' || values.owner === 'Учащиеся')
                      ? studentList && arrayForSelect(studentList, 'fio', 'mid')
                      : []
                }
                width='120px'
                value={values.mid}
                setFieldValue={setFieldValue}
                withoutAll
                required
                error={error('mid')}
              />
            </div>

            <div className={styles.inputsRow}>
              <CustomSelect
                title='Вид документа'
                valuesName="dtype"
                className={styles.selectModal}
                options={typeOfDocumentslist && arrayForSelect(typeOfDocumentslist, 'name', 'xp_key')}
                width='120px'
                value={values.dtype}
                setFieldValue={setFieldValue}
                withoutAll
                required
                error={error('dtype')}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Дата выдачи'
                type='date'
                required
                value={values.ddate}
                error={error('ddate')}
                onChange={(e) => setFieldValue('ddate', e.target.value)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Серия'
                name='dseries'
                value={values.dseries}
                onChange={handleChange}
                error={error('dseries')}
                style={{ width: '300px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Номер'
                name='dnum'
                value={values.dnum}
                onChange={handleChange}
                error={error('dnum')}
                style={{ width: '300px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Примечание'
                name='dtext'
                value={values.dtext}
                onChange={handleChange}
                error={error('dtext')}
                style={{ width: '300px' }}
              />

            </div>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal >
  )
}
